<template>
    <div class="group normal-text hover-bold">
        <a :href="'/boards/' + group.slug">
        <div class="group-image">
            <img :src="`${ group.image }?width=60`" alt="" onerror="this.src='/img/image.resized.jpg?width=60'">
        </div>
        <div class="group-name">
            {{ group.name }}
            <span class="notification-count hidden notification-badge" :data-notify-id="'groups.boards.' + group.slug"></span>
        </div>
        </a>
    </div>
</template>
<script>
    import Global from '../../mixins/Global';

    export default {
        name: 'NavBoard',

        mixins: [Global],

        props: {
            group: {
                required: true,
                type: Object,
            },
        },
    };
</script>